import React from 'react'
import ProductsBanner from '../components/ProductsBanner'
import Header from '../components/Header'
import Footer from '../components/Footer'
import IndividualProduct from '../components/individualProduct';
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import { Helmet } from "react-helmet";
const BloodGlucose = () => {
  const title = "Dr. Chek D - Accurate Blood Glucose Monitoring";
  const description = "The Dr. Chek D Glucose Oxidase-based Blood Glucose Meter provides accurate and reliable blood sugar testing. Ideal for home glucose monitoring and diabetes management.";
  const productData = {
    name: "Dr. Chek D ",
    image: "/images/Dr Chek D (GOD)_270x270.webp",
    "description":"The Dr. Chek D Glucose Oxidase based Blood Glucose Meter offers accurate and reliable blood glucose monitoring for effective diabetes management. Utilizing advanced glucose oxidase biosensor technology, this meter provides fast results, minimizing wait times. Ideal for home glucose testing, it empowers users to track blood sugar levels with ease. The Dr. Chek D is designed for user-friendliness, making blood glucose testing accessible to all. Its compact design is perfect for travel, ensuring convenient diabetes management on the go. Get accurate readings with our glucose meter and test strips, essential tools for maintaining healthy blood sugar.",
    features: [
      "Amperometric Biosensor – GOD",
      "	Result Time of 5 Seconds",
      "Minimal Sample of 0.5 uL",
      "	Acceptable HCT Range ",
      "Fasting & Post Meal Indicator",
      "	Enhanced Shelf life"
    ],
    "brochure": {
      "pages": [
        "/images/Dr-Chek-D-Glucose-Meter-brochure-page-1.jpg",
        "/images/Dr-Chek-D-Glucose-Meter-brochure-page-2.jpg",
       
      ],
      "url": "/Dr.Chek-D-Glucose-Meter-brochure.pdf"
    }
  };

return (
  
<div>
<Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="Blood glucose meter, Glucose meter, Blood sugar meter, Diabetes meter, Blood glucose monitoring, Blood sugar testing, Home glucose testing, glucometer, bgm" />
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://yourwebsite.com" />
    </Helmet>
    <Header/>
    <ProductsBanner
    title="Dr. Chek D "
    backgroundImage="/images/dr-chek-banner-001.png"
    backgrond="cover"
    height="400px"
  />
     <IndividualProduct product={productData} />
     <Footer/>
    <WhatsAppFloatingButton/>
</div>
)
}

export default BloodGlucose